import React, { useReducer } from "react";
import {
  SET_CAMPAIGNS,
  SET_CAMPAIGNS_SEARCHED,
  SET_SORT_VALUE,
  SET_SEARCH_VALUE,
  EDIT_CAMPAIGN,
  SET_SCALING_STATUS,
} from "../types";

import ScalingReducer from "./ScalingReducer";
import ScalingContext from "./ScalingContext";

const ScalingState = (props) => {
  const default_scaling_data = {
    campaign_id: "",
    action_id: "",
    actions: "",
    created_at: "",
    updated_at: "",
    completed_at: "",
    status: "PENDING",
  };
  const sort_options = [
    {
      key: "profit",
      value: "Profit",
    },
    {
      key: "created_at",
      value: "Creation Date",
    },
    {
      key: "laptop",
      value: "Laptop",
    },
    {
      key: "angle",
      value: "Angle",
    },
    {
      key: "language",
      value: "Language",
    },
    {
      key: "vapt",
      value: "VAPT",
    },
    {
      key: "scaling_status",
      value: "Scaling Status",
    },
  ];
  const scaling_status_options = ["TESTING", "OPTIMIZING", "SCALING"];
  const action_status_options = ["PENDING", "COMPLETE"];

  const initialState = {
    campaigns: null,
    campaigns_searched: null,
    sort_value: "profit",
    search_value: {
      media_buyer: "",
      scaling_status: ["TESTING", "OPTIMIZING", "SCALING"],
      action_status: [],
      text: "",
    },
    index_selected: null,
    campaign_selected: null,
    scaling_status: null,
  };

  const [state, dispatch] = useReducer(ScalingReducer, initialState);

  // Set All Campaigns
  const setCampaigns = (data) => {
    dispatch({
      type: SET_CAMPAIGNS,
      payload: data,
    });
  };

  // Set Campaigns Searched
  const setCampaignsSearched = (data) => {
    dispatch({
      type: SET_CAMPAIGNS_SEARCHED,
      payload: data,
    });
  };

  // Set Sort Value
  const setSortValue = (data) => {
    dispatch({
      type: SET_SORT_VALUE,
      payload: data,
    });
  };

  // Set Search Value
  const setSearchValue = (data) => {
    const { media_buyer, scaling_status, action_status, text } = data;

    dispatch({
      type: SET_SEARCH_VALUE,
      payload: {
        media_buyer,
        scaling_status,
        action_status,
        text,
      },
    });
  };

  // Set Selected Index, Campaign
  const editCampaign = (index_selected, campaign_selected) => {
    // * RESET MODE: index = null, campaign = null
    // * EDIT MODE : index != null, campaign != null
    dispatch({
      type: EDIT_CAMPAIGN,
      payload: {
        index_selected,
        campaign_selected,
      },
    });
  };

  // Set Scaling Status Variable For Update
  const setScalingStatus = (data) => {
    dispatch({
      type: SET_SCALING_STATUS,
      payload: data,
    });
  };

  return (
    <ScalingContext.Provider
      value={{
        setCampaigns,
        campaigns: state.campaigns,
        setCampaignsSearched,
        campaigns_searched: state.campaigns_searched,

        setSortValue,
        sort_value: state.sort_value,
        setSearchValue,
        search_value: state.search_value,

        editCampaign,
        index_selected: state.index_selected,
        campaign_selected: state.campaign_selected,

        setScalingStatus,
        scaling_status: state.scaling_status,

        default_scaling_data,
        sort_options,
        scaling_status_options,
        action_status_options,
      }}
    >
      {props.children}{" "}
    </ScalingContext.Provider>
  );
};

export default ScalingState;
